import { AbstractControl, ValidatorFn } from '@angular/forms';

export function NoWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } => {
    if (!control || !control.value || typeof control.value !== 'string') {
      return null;
    }

    const isWhitespace = (control.value as string).indexOf(' ') >= 0;

    return isWhitespace ? { whitespace: { value: control.value } } : null;
  };
}
